import { render } from "./Subtopics.vue?vue&type=template&id=ceb2dda4"
import script from "./Subtopics.vue?vue&type=script&lang=js"
export * from "./Subtopics.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__